import {cn} from '@/lib/utils';
import LogoSvg from './logo_beta.svg?react';
import LogoMarkSvg from './logo_mark.svg?react';

interface LogoProps {
  className?: string;
  variant?: 'dark' | 'light';
  markOnly?: boolean;
  /** Override the default fill color with a custom Tailwind fill class */
  fillClassName?: string;
}

/**
 * Shared brand logo used across navbar, footer, and other surfaces.
 * Defaults to dark (black) fill; use `variant="light"` for white fill.
 */
export function Logo({
  className,
  variant = 'dark',
  markOnly = false,
  fillClassName,
}: LogoProps) {
  const fill = fillClassName ?? (variant === 'light' ? 'fill-white' : 'fill-black');

  if (markOnly) {
    return (
      <LogoMarkSvg
        className={cn(
          'h-5 w-auto transform-gpu',
          fill,
          className
        )}
      />
    );
  }

  return (
    <LogoSvg
      className={cn(
        'h-5 w-auto transform-gpu',
        fill,
        className
      )}
    />
  );
}
